var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          staticClass: "import-se-dialog",
          attrs: {
            title: _vm.dialogTitle,
            width: "auto",
            visible: _vm.dialogVisible,
            "z-index": 2000,
            scrollbar: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: _vm.onClosed,
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-lr" },
            [
              _c(
                "div",
                { staticClass: "form" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "search-input",
                      attrs: { model: _vm.form, "label-width": "80px" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "HCPID:", prop: "hcpId" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                placeholder: "Input HCP Number",
                                clearable: "",
                              },
                              nativeOn: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.onSearch.apply(null, arguments)
                                },
                              },
                              model: {
                                value: _vm.form.hcpId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "hcpId", $$v)
                                },
                                expression: "form.hcpId",
                              },
                            },
                            [
                              _c("template", { slot: "prepend" }, [
                                _vm._v("CN-"),
                              ]),
                              _c("template", { slot: "append" }, [
                                _vm._v("HCP"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            required: "",
                            label: "Name:",
                            "show-message": false,
                            prop: "fullName",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              "prefix-icon": "el-icon-search",
                              placeholder: "Input name",
                              clearable: "",
                            },
                            nativeOn: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.onSearch.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.form.fullName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "fullName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.fullName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "search-btn",
                              attrs: {
                                type: "primary",
                                disabled: _vm.searchDisabled,
                              },
                              on: { click: _vm.onSearch },
                            },
                            [_vm._v(" Search ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-alert",
                { attrs: { type: "info", "show-icon": "", closable: false } },
                [
                  _c("div", { staticClass: "tips" }, [
                    _c("p", [
                      _vm._v(
                        " 1. Please import HCP from the source tagged eAuthorship in priority. "
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        " 2. If there is no available doctor who you are looking for, please follow the existing process to create doctor in Veeva CRM and HCP information will be refreshed in eMSL "
                      ),
                      _c("span", { staticClass: "white-spce" }, [
                        _vm._v("soon."),
                      ]),
                    ]),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.role == _vm.roleCode,
                            expression: "role == roleCode",
                          },
                        ],
                      },
                      [
                        _vm._v(
                          " 3. If there is no available customer (non-doctor) who you are looking for, please click "
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-link sqBtn",
                            attrs: {
                              type: "text",
                              disabled:
                                _vm.isCreateNewDisable ||
                                _vm.role != _vm.roleCode,
                            },
                            on: {
                              click: function ($event) {
                                _vm.handleNewSE(), (_vm.type = "here")
                              },
                            },
                          },
                          [_vm._v("here ")]
                        ),
                        _vm._v(" to create new one. "),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.tableLoading,
                      expression: "tableLoading",
                    },
                  ],
                  ref: "singleTable",
                  attrs: {
                    data: _vm.tableData,
                    height: "36vh",
                    "max-height": "47.05vh",
                    "element-loading-text": "Loading...",
                  },
                  on: { "current-change": _vm.handleCurrentSelectChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "", width: "30" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-radio",
                              {
                                attrs: { label: row },
                                model: {
                                  value: _vm.selection,
                                  callback: function ($$v) {
                                    _vm.selection = $$v
                                  },
                                  expression: "selection",
                                },
                              },
                              [_c("i")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "Name", width: "80" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "province",
                      label: "Province",
                      width: "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "city", label: "City", width: "120" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "hospital",
                      label: "Hospital / Institution",
                      "min-width": "200",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "department",
                      label: "Department",
                      "min-width": "130",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "source", label: "Source", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.source === "EA"
                              ? _c("el-tag", { attrs: { type: "success" } }, [
                                  _vm._v(" eAuthorship"),
                                ])
                              : _c("el-tag", { attrs: { type: "warning" } }, [
                                  _vm._v("CMDS"),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "hcpId", label: "HCPID", width: "100" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Operation",
                      align: "center",
                      width: "110",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "cell-import" },
                              [
                                row === _vm.selection
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "cell-import-btn",
                                        attrs: {
                                          plain: "",
                                          loading: _vm.importing,
                                        },
                                        on: { click: _vm.onImport },
                                      },
                                      [_vm._v(" Import ")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm.total > 10
                ? _c("div", { staticClass: "pagination-wrap" }, [
                    _c(
                      "div",
                      { staticClass: "actions" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.currentPage,
                            "page-sizes": [10, 25, 50, 100],
                            "page-size": _vm.pageSize,
                            layout: "total, sizes, prev, pager, next, jumper",
                            total: _vm.total,
                          },
                          on: {
                            "size-change": _vm.handleSizeChange,
                            "current-change": _vm.handleCurrentChange,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c("NewSEDialog", {
        attrs: {
          visible: _vm.newSEDialogVisible,
          data: _vm.selectSE,
          type: _vm.type,
        },
        on: {
          "update:visible": function ($event) {
            _vm.newSEDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.selectSE = $event
          },
          closed: _vm.onNewSEClosed,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }